<template>
  <v-container class="ma-0 pa-0" style="height: 100%; width: 100%">
    <v-card style="height: 100%; width: 100%" flat>
      <!-- <v-row style="position: absolute; width: 100%; padding-bottom: 20px">
        <v-spacer></v-spacer>
        <v-col cols="auto" class="ma-0 pa-1">
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span class="graphIcon" v-on="on" @click="toggleGraph">
                  <v-icon :disabled='!audience_data'> mdi-swap-horizontal-bold </v-icon>
                </span>
              </template>
              <TooltipDescription title="Switch graph view"></TooltipDescription>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="auto" class="ma-0 pa-1">
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span class="graphIcon" v-on="on" @click="overlay = true">
                  <v-icon> mdi-cog</v-icon>
                </span>
              </template>
              <TooltipDescription
                title="Social Network Graph Settings"
              ></TooltipDescription>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="auto" class="ma-0 pa-1">
          <div>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <span class="graphIcon" v-on="on">
                  <v-icon> mdi-information-variant </v-icon>
                </span>
              </template>
              <v-row class="ma-0 pa-0" style="max-width: 30vw">
                <v-col cols="12" class="ma-0 pa-0 py-2">
                  <span class="tooltip_title">Social Network Graph</span>
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <span class="tooltip_description"
                    >The social network graph is a visual representation of how word of
                    mouth travels through audiences.</span
                  >
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <span class="tooltip_description"
                    >View how awarness increases and tune your model to best represent
                    your situation at the design phase.</span
                  >
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col cols="8">
                      <v-simple-table dark style="background-color: #00000000">
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td><v-icon color="#0bb4ff">mdi-circle</v-icon></td>
                              <td class="tooltip_title">Unaware</td>
                            </tr>
                            <tr>
                              <td><v-icon color="#e60049">mdi-circle</v-icon></td>
                              <td class="tooltip_title">Aware</td>
                            </tr>
                            <tr>
                              <td><v-icon color="#50e991">mdi-circle</v-icon></td>
                              <td class="tooltip_title">Converted</td>
                            </tr>
                            <tr>
                              <td><v-icon color="#9b19f5">mdi-circle</v-icon></td>
                              <td class="tooltip_title">Recovered</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-row>
            </v-tooltip>
          </div>
        </v-col>
      </v-row> -->
      <div v-if="graphToggled">
        <v-row>
          <v-col cols="12" style="padding-top: 30px;">
            <PurchaseCycleChart
              :dataset="chartData"
            ></PurchaseCycleChart>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col cols="12" style="padding-top: 30px;">
            <v-overlay :absolute="true" :value="overlay">
              <v-card style="height: 100%">
                <v-card-text style="height: 100%">
                  <v-subheader>Node Density</v-subheader>
                  <v-card-text style="height: 75%">
                    <v-slider
                      v-model="nodeDensity"
                      color="blue"
                      :max="3"
                      step="1"
                      ticks="always"
                      tick-size="4"
                      append-icon="mdi-arrow-up-drop-circle-outline"
                      prepend-icon="mdi-arrow-down-drop-circle-outline"
                    ></v-slider>
                  </v-card-text>
                  <v-card-text class="overlayButtonContainer">
                    <v-btn color="success" @click="confirmOnClick" class="overlayButton">
                      Confirm
                    </v-btn>
                    <v-btn @click="overlay = false" class="overlayButton"> Cancel </v-btn>
                  </v-card-text>
                </v-card-text>
              </v-card>
            </v-overlay>
            <NetworkGraph :dataset="networkGraphData" />
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="slider_notches_tmp > 0">
          <v-spacer v-if="outwards_only"></v-spacer>
          <v-col :cols="12" class="ma-0 pa-1">
            <v-slider
              v-model="sliderValue"
              color="primary"
              :max="slider_notches_tmp-1"
              step="1"
              ticks="always"
              tick-size="4"
              hide-details
              @end="slider_on_change"
            >
            </v-slider>
          </v-col>
          <v-spacer v-if="inwards_only"></v-spacer>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="slider_notches_tmp > 0">
          <v-col cols="5" class="ma-0 pa-1">
            <v-row class="ma-0 pa-0">
              <v-spacer></v-spacer>
              <v-col cols="auto" class="ma-0 pa-0">
                <v-btn plain block @click="slider_on_change(sliderValue - 1)" :disabled="sliderValue == 0">
                  <span class="slider-description">Consolidate</span>
                  <v-icon>mdi-arrow-left-thick</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" class="ma-0 pa-1">
            <v-row class="ma-0 pa-0" style="width: 100%">
              <v-col cols="12" class="ma-0 pa-0">
                <v-btn plain block @click="slider_on_change(starting_notch)">
                  <v-icon>mdi-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" class="ma-0 pa-1">
            <v-row class="ma-0 pa-0">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-btn plain block @click="slider_on_change(sliderValue + 1)" :disabled="sliderValue == slider_notches_tmp - 1">
                  <v-icon>mdi-arrow-right-thick</v-icon>
                  <span class="slider-description">Expand</span>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-container>
</template>

<script>
// import TooltipDescription from "@/components/Utility/TooltipDescription.vue";
import chartConfig from "@/configs/Audiences/audiences_stats_chart_config.json";
import PurchaseCycleChart from "./TalkTrendChartComponents/PurchaseCycleChart.vue";
import NetworkGraph from "./TalkTrendChartComponents/NetworkGraph.vue";
import network_graph_sample_data from "@/test_data/demo_data/network_graph_sample_data_multi.json";


export default {
  name: "TalkTrendGraph",
  props: ["audience_info", "audience_data_graph_imgs", "audience_data", "audience_data_tbl", "slider_notches_tmp", "starting_notch", "inner_notches", "outer_notches", "current_slider_id"],
  components: {
    PurchaseCycleChart,
    NetworkGraph
  },
  mounted() {
  },
  watch: {
    starting_notch: {
      handler: function () {
        if (this.current_slider_id !== undefined && this.current_slider_id !== null) {
          this.sliderValue = this.current_slider_id;
          return;
        }

        this.slider_on_change(this.starting_notch);
      }
    },
    audience_data_tbl: {
      handler: function () {
        this.networkGraphData = this.generate_graph_for_slider(50, [...this.audience_data_tbl])
      },
      deep: true,
    },
    current_slider_id: {
      handler: function (value) {
        if (value !== undefined && value !== null) {
          this.sliderValue = value;
        }
      },
    }
  },
  data: () => ({
    slider_notches: 0,
    graph_url: null,
    sliderValue: 0,
    overlay: false,
    absolute: false,
    opacity: 0.5,
    nodeDensity: 1,
    inwards_only: true,
    outwards_only: true,
    slider_size: 6,
    graphToggled: false,
    chartConfig: chartConfig,
    networkGraphData: network_graph_sample_data
  }),
  computed: {
    chartData: function () {
      let chartData = [["index","Unaware", "Aware", "Converted", "Recovered", "Conversion Rate"]];
      let rawChartData = this.audience_data[0][0]
      
      let dataRow = []
      for(let i = 0; i < rawChartData['U'].length; i++){
        dataRow = [
          i,
          rawChartData['U'][i],
          rawChartData['A'][i],
          rawChartData['C'][i],
          rawChartData['R'][i],
          rawChartData['Daily Total Conversion Rate'][i]
        ]
        chartData.push(dataRow)
      }
      return chartData;
    }
  },
  methods: {
    //---------------------------------------------------------
    // Helper functions
    //---------------------------------------------------------
    roundArray: function(arr) {
      return arr.map(v => Math.round(v));
    },

    min: function (arr) {
      return Math.min(...arr);
    },

    max: function(arr) {
      return Math.max(...arr);
    },

    sample: function(array, n) {
      const out = [];
      const copy = [...array];
      n = Math.min(n, copy.length);

      for (let i = 0; i < n; i++) {
        const idx = Math.floor(Math.random() * copy.length);
        out.push(copy[idx]);
        copy.splice(idx, 1);
      }
      return out;
    },

    build_temp: function (populations, number_of_nodes, use_min = false) {
      const divisor = use_min
        ? this.min(populations) / number_of_nodes
        : this.max(populations) / number_of_nodes;

      // Initial node assignments
      let temp = populations.map(p => {
        const v = Math.round(p / divisor);
        return v === 0 ? 1 : v;
      });

      // Total nodes currently assigned
      const total = temp.reduce((a, b) => a + b, 0);

      // If total <= 750, we're done
      if (total <= 750) return temp;

      // Otherwise proportionally scale down to max 750
      const scale = 750 / total;

      // Apply scaling & ensure minimum of 1 node each
      temp = temp.map(v => {
        const scaled = Math.floor(v * scale);
        return scaled < 1 ? 1 : scaled;
      });

      // After scaling, total might still be slightly off due to rounding.
      // Final correction pass to enforce max = 750 exactly.
      let newTotal = temp.reduce((a, b) => a + b, 0);

      while (newTotal > 750) {
        // Reduce largest values first
        const idx = temp.indexOf(Math.max(...temp));
        temp[idx] -= 1;
        newTotal -= 1;
      }

      return temp;
    },

    //---------------------------------------------------------
    // build_nodes  (seed first, then con0, con1, con2...)
    //---------------------------------------------------------
    build_nodes: function(temp, true_pop, mode) {
      const seedIndex = (mode === "con")
          ? temp.length - 1        // seed is last bucket in con mode
          : 0;                     // seed is first in expansion mode

      const otherIndexes = [...temp.keys()].filter(i => i !== seedIndex);

      const reorderedTemp = [temp[seedIndex], ...otherIndexes.map(i => temp[i])];
      const reorderedPop  = [true_pop[seedIndex], ...otherIndexes.map(i => true_pop[i])];

      const bucket_map = [];
      reorderedTemp.forEach((count, bucketIdx) => {
        for (let j = 0; j < count; j++) bucket_map.push(bucketIdx);
      });

      const per_node_pop = bucket_map.map(b => reorderedPop[b] / reorderedTemp[b]);

      const nodes = bucket_map.map((bucketIdx, i) => ({
        id: i,
        name: `node${i}`,
        symbolSize: Math.round(Math.log(reorderedTemp[bucketIdx]) + 4),
        value: per_node_pop[i],
        category: null
      }));

      for (let newIndex = 0; newIndex < reorderedTemp.length; newIndex++) {

        let category;
        if (newIndex === 0) {
          category = "seed_audience";
        } else {
          // For "con" mode assign con0, con1, con2...
          if (mode === "con") {
            category = `con${newIndex - 1}`;
          } else {
            category = `exp${newIndex}`;
          }
        }

        nodes.forEach(node => {
          if (bucket_map[node.id] === newIndex) node.category = category;
        });
      }

      return nodes;
    },

    build_links: function (temp, seed_pop, wom_and_pop_list, mode){
      const bucket_map = [];
      temp.forEach((t, i) => {
          for (let j = 0; j < t; j++) bucket_map.push(i);
      });

      const nNodes = bucket_map.length;

      const womByBucket = wom_and_pop_list.map(w => w.wom);

      const groups = {};
      for (let i = 0; i < nNodes; i++) {
          const b = bucket_map[i];
          if (!groups[b]) groups[b] = [];
          groups[b].push(i);
      }

      const rand = arr => arr[Math.floor(Math.random() * arr.length)];

      const links = [];
      const adjacency = Array.from({ length: nNodes }, () => new Set());

      const addLink = (a, b) => {
          if (a === b) return;
          if (adjacency[a].has(b)) return;

          adjacency[a].add(b);
          adjacency[b].add(a);

          links.push({ source: a, target: b });
      };

      for (let bucketIndex in groups) {
          const group = groups[bucketIndex];
          if (group.length <= 1) continue;

          const wom = womByBucket[bucketIndex] ?? 0;

          // WOM → max links (1–8)
          let maxLinks = (wom < 100)
              ? 2
              : Math.min(8, Math.floor((wom / 100) * 2));

          group.forEach(node => {
              const possibleTargets = group.filter(x => x !== node);

              // 1 to maxLinks (depending on group size)
              const desired = Math.min(maxLinks, possibleTargets.length);

              // Must have ≥1 link
              addLink(node, rand(possibleTargets));

              // Add additional WOM-based links
              for (let k = 1; k < desired; k++) {
                  addLink(node, rand(possibleTargets));
              }
          });
      }

      const allBuckets = Object.keys(groups).map(b => parseInt(b));

      for (let bucketIndex in groups) {
          const group = groups[bucketIndex];
          const wom = womByBucket[bucketIndex] ?? 0;

          // WOM → max within-group links, but cross is softer
          let maxCross = (wom < 100)
              ? 1
              : Math.max(1, Math.floor(Math.min(8, (wom / 100) * 2) / 2));

          // Eligible target buckets (all except current)
          const otherBuckets = allBuckets.filter(b => b != bucketIndex);

          if (otherBuckets.length === 0) continue;

          group.forEach(node => {
              if(mode == 'exp'){
                // 25% probability of attempting a cross connection
                if (Math.random() > 0.25) return;  // skip 75% of the time
              }

              // CROSS CATEGORY TARGETS
              const crossTargets = otherBuckets.flatMap(
                  b => groups[b] ?? []
              );

              if (crossTargets.length === 0) return;

              // Number of cross links allowed
              const desiredCross = Math.min(maxCross, crossTargets.length);

              for (let k = 0; k < desiredCross; k++) {
                  addLink(node, rand(crossTargets));
              }
          });
      }

      for (let i = 0; i < nNodes; i++) {
          if (adjacency[i].size === 0) {
              const bucket = bucket_map[i];
              const group = groups[bucket];
              if (group.length > 1) {
                  addLink(i, rand(group.filter(x => x !== i)));
              } else {
                  // Only node in category — link to random other bucket
                  const other = rand([...Array(nNodes).keys()].filter(x => x !== i));
                  addLink(i, other);
              }
          }
      }

      return links;
    },
    //---------------------------------------------------------
    // generate_graph_for_slider
    //---------------------------------------------------------
    generate_graph_for_slider: function(number_of_nodes, subset) {
      const populations = subset
        .map(r => r.population)
        .sort((a, b) => a - b);

      const mode = subset.some(r => r.type === "AII") ? "con" : "exp";

      const temp = this.build_temp(populations, number_of_nodes, mode === "exp");
      console.log('tmp', temp)

      const nodes = this.build_nodes(temp, populations, mode);

      const seed_row = subset.find(r => r.type === "p");
      const seed_pop = seed_row.population;

      const wom_and_pop_list = subset
        .sort((a, b) => a.population - b.population)
        .map(r => ({ wom: r.wom, population: r.population }));

      const links = this.build_links(temp, seed_pop, wom_and_pop_list, mode);

      const categories = [...new Set(nodes.map(d => d.category))].map((cat, index) => ({
          name: cat,
          value: index
        }));
              
      
      return { nodes, links , categories};
    },
    slider_on_change: function (value) {
      let val = value;
      if (val < 0) {
        val = 0;
      } else if (val > this.slider_notches_tmp - 1) {
        val = this.slider_notches_tmp - 1;
      }
      this.sliderValue = val;
      this.$emit("sliderOnChange", val)
    },
    toggleGraph: function () {
      if(this.audience_data) {
        this.graphToggled = !this.graphToggled;
      }
    },
    confirmOnClick: function () {
      this.$emit("nodeDensityChanged", this.nodeDensity);
      this.overlay = false;
    },
  },
};
</script>

<style scoped>
.slider-description {
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 1em;
  color: grey;
  text-align: center;
}

.graphIcon {
  color: grey;
  cursor: pointer;
}

.overlayButtonContainer {
  display: flex;

  .overlayButton {
    flex: 1;
  }
}

::v-deep .v-overlay__content {
  height: 100%;
  width: 100%;
}

.tooltip_description {
  font-family: "Poppins" !important;
  font-weight: 200;
  color: "white" !important;
}
.tooltip_title {
  font-family: "Poppins" !important;
  font-weight: 400;
}
</style>
